var _rect, _circle, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#f8f9fa"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 120,
    r: 60,
    fill: "#e8f5e9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170 120 L190 140 L230 100",
    stroke: "#2e7d32",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 200,
    width: 160,
    height: 20,
    rx: 10,
    fill: "#c8e6c9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 230,
    width: 120,
    height: 20,
    rx: 10,
    fill: "#c8e6c9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIllustration);
export default __webpack_public_path__ + "static/media/health-illustration.a19968d9d310fd239083ba691a5e0655.svg";
export { ForwardRef as ReactComponent };